import { render, staticRenderFns } from "./SubfolderListTable.vue?vue&type=template&id=160ff14e&"
import script from "./SubfolderListTable.vue?vue&type=script&lang=js&"
export * from "./SubfolderListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports